module.exports = "<footer *ngIf=\"footerText\"><p>{{footerText}}</p></footer>"